enum TaskPublishType {
    PAYMENT = 'payment',
    QUOTA = 'quota',
    CREDIT = 'credit',
    MANUAL = 'manual',
}

export default TaskPublishType;
